import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Row, Col, Container } from 'react-bootstrap';
import { appConfig } from '../config/app';
import SocialMediaCard from './SocialMediaCard';

const Footer = ({auth}) => {
  return (
    <footer className="footer-dark">
      <Container>
        {/* Social Media Section - Inside Footer */}
        <Row className="mb-4">
          <Col xs={12}>
            <div id="social-section" style={{ position: 'relative', top: '-24px' }}></div>
            <div style={{ paddingTop: '24px' }}></div>
            <SocialMediaCard />
          </Col>
        </Row>

        {/* Desktop Footer */}
        <Row className="d-none d-lg-flex justify-content-between align-items-center mb-4">
          <Col lg={6}>
            <div className="d-flex align-items-center">
              <span className="me-4" style={{ color: 'var(--text-secondary)' }}>
                © {new Date().getFullYear()}{' '}
                <a 
                  href={appConfig.company.companyUrl}
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
                >
                  {appConfig.company.companyName}
                </a>
                {' '}{appConfig.company.dbaText}
              </span>
            </div>
          </Col>
          <Col lg={6}>
            <div className="d-flex justify-content-end align-items-center">
              <Link to="/terms" className="me-4">Terms</Link>
              <Link to="/privacy" className="me-4">Privacy</Link>
              <a 
                href={appConfig.social.discord}
                target="_blank" 
                rel="noopener noreferrer"
                style={{ fontSize: '1.5rem', color: '#5865f2' }}
              >
                <i className="fab fa-discord"></i>
              </a>
            </div>
          </Col>
        </Row>

        {/* Desktop Legal Disclaimer */}
        <Row className="d-none d-lg-flex mb-3">
          <Col xs={12}>
            <div className="legal-disclaimer legal-disclaimer-desktop">
              <p>
                Teq Crew, LLC dba RecapVid is not connected, associated, endorsed, or authorized by the NFL or any other league or team. All trademarks, logos, and brand names belong to their respective owners. All team, product, and service names used are for identification purposes only. Use of these names, trademarks, and brands does not imply affiliation or endorsement.
              </p>
              <p>
                Teq Crew, LLC dba RecapVid is not an online sports betting or gambling operator, or a gambling or sports betting website of any kind.
              </p>
            </div>
          </Col>
        </Row>

        {/* Mobile Footer */}
        <Row className="d-block d-lg-none">
          <Col xs={12} className="text-center mb-3">
            <span style={{ color: 'var(--text-secondary)' }}>
              © {new Date().getFullYear()}{' '}
              <a 
                href={appConfig.company.companyUrl}
                target="_blank" 
                rel="noopener noreferrer"
                style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}
              >
                {appConfig.company.companyName}
              </a>
              {' '}{appConfig.company.dbaText}
            </span>
          </Col>
          <Col xs={12} className="text-center mb-3">
            <div className="d-flex justify-content-center gap-4">
              <Link to="/terms">Terms</Link>
              <Link to="/privacy">Privacy</Link>
            </div>
          </Col>
          <Col xs={12} className="text-center">
            <a 
              href={appConfig.social.discord}
              target="_blank" 
              rel="noopener noreferrer"
              style={{ fontSize: '2rem', color: '#5865f2' }}
            >
              <i className="fab fa-discord"></i>
            </a>
          </Col>
        </Row>

        {/* Mobile Legal Disclaimer */}
        <Row className="d-block d-lg-none">
          <Col xs={12}>
            <div className="legal-disclaimer legal-disclaimer-mobile">
              <p>
                Teq Crew, LLC dba RecapVid is not connected, associated, endorsed, or authorized by the NFL or any other league or team. All trademarks, logos, and brand names belong to their respective owners. All team, product, and service names used are for identification purposes only. Use of these names, trademarks, and brands does not imply affiliation or endorsement.
              </p>
              <p>
                Teq Crew, LLC dba RecapVid is not an online sports betting or gambling operator, or a gambling or sports betting website of any kind.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

function mapStateToProps({auth}) {
  return { auth };
}

export default connect(mapStateToProps)(Footer);
